import { render, staticRenderFns } from "./PaypalPage.vue?vue&type=template&id=48051faa&scoped=true&"
import script from "./PaypalPage.vue?vue&type=script&lang=js&"
export * from "./PaypalPage.vue?vue&type=script&lang=js&"
import style0 from "./PaypalPage.vue?vue&type=style&index=0&id=48051faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48051faa",
  null
  
)

export default component.exports